import { FindProductLinesUseCase } from '@/domains/product-line/usecases';
import ProductLineRepoImplement from '../adapters/repositories/product-lines.repo';
import { useRequest } from 'ahooks';
import { FindOneProductLinePayload } from '@/domains/product-line/ports/payloads';

export function useFindOneProductLineViewModel(options?: any) {
  const usecase = new FindProductLinesUseCase(new ProductLineRepoImplement());

  const req = useRequest(
    async (payload: FindOneProductLinePayload) => {
      const result = await usecase.findOne(payload);
      return result;
    },
    { manual: true, ...(options || {}) },
  );
  return req;
}
